import React, { Component } from 'react';
import $ from 'jquery';
import { Panel } from 'react-bootstrap';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';


BigCalendar.momentLocalizer(moment);

class Records extends Component {
	
	constructor(props) {
		super(props);
		var today = new Date();
		this.state = {
			year: today.getFullYear(),
			month: today.getMonth()+1,
      events: [],
		}
    this.loadEvents = this.loadEvents.bind(this);
    this.handleNavigate = this.handleNavigate.bind(this);
	}

	componentDidMount() {
		this.loadEvents(this.state.year,this.state.month);
	}

	loadEvents(year,month) {
		var that = this;
		if (this.props.isLogin) {
			$(function(){$.ajax({
				url: URL + 'api/test_records_stat/?year=' + year + '&month=' + month,
				headers: {
					'Authorization': 'JWT ' + that.props.token,
				},
				type: "GET",
				dataType: "json",
				success: function(data) {
          var tmp = [];
          var i = 0;
          data.forEach((d)=>{
            i = i + 1;
            var start = new Date(d.day+" 00:00:00");
            var end = new Date(d.day+" 12:00:00");
            tmp.push({'id':i,'title':d.title,'start':start,'end':end})
          });
          that.setState({events:tmp});
				},
				error: function(xhr, status, err) {
					console.log(err.Message);
					that.setState({events:[]});
				}
			})});
		}
  }

  handleNavigate(date, view, action) {
    var check = moment(date, 'YYYY/MM/DD');
    var year = check.format('YYYY');
    var month = check.format('M');
    this.loadEvents(year,month);
  }

	render() {
		return( 
			<Panel>
			  <Panel.Heading>
			   我的测试记录 
			  </Panel.Heading>
			  <Panel.Body>
			    {this.props.isLogin?(<BigCalendar events={ this.state.events } defaultView="month" style={{height:"500px"}} views={['month']} messages={{next:"下个月",previous:"上个月",today:"今天"}} defaultDate={new Date()} onNavigate={this.handleNavigate} />):(<p>你尚未登录，请登录。</p>)}
			  </Panel.Body>
			  </Panel>
			  )
	}

}

export default Records;



// WEBPACK FOOTER //
// ./src/Records.js